import React from "react";

const Button = ({ color, size, children, disabled, onClick, name, title }) => {
  const BUTTON_COLOR = {
    PRIMARY:
      "bg-workfully-700 text-white rounded-md hover:bg-workfully-800 active:bg-workfully-900",
    SECONDARY:
      "bg-white text-gray-700 border border-gray-100 rounded-md hover:bg-gray-100 active:bg-gray-200",
    DEFAULT:
      "bg-transparent text-gray-700 hover:bg-gray-100 active:bg-gray-200",
    DISABLED: "bg-gray-50 text-gray-400 border border-gray-300 rounded",
    ICON: "bg-transparent text-gray-700 flex items-center justify-center rounded-md hover:bg-gray-100 active:bg-gray-200",
    BLUE: "bg-white text-blue-600 rounded-md shadow-sm hover:bg-blue-50 active:bg-blue-100",
  };

  const BUTTON_SIZE = {
    SM: "h-9 ft-sm py-2 px-4",
    SMI: "h-9 ft-sm p-2",
    LG: "h-12 ft-lg py-3 px-6",
    LGI: "h-9 ft-sm p-3",
    FULL: "w-full h-12 ft-lg py-3 px-6",
    ICON: "h-9 w-9",
  };
  const colorClassName = BUTTON_COLOR[color || "PRIMARY"];
  const sizeClassName = BUTTON_SIZE[size || "SM"];

  return (
    <button
      type={"button"}
      name={name}
      title={title}
      className={
        "flex flex-row items-center justify-center gap-2 transition-colors " +
        sizeClassName +
        " " +
        colorClassName
      }
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
